// components/portal/SourceFocusMark.tsx
//
// The logo of the brand the agent is working on, pulsing at the head of the chat's live line
// ("Thinking 10s"), where the eye already is while the agent works (owner, 2026-09-26). It replaced
// the composer's "Selected: <brand>" chip. Self-gating: no brand in focus, nothing rendered, so the
// live line of every other module is untouched.
import React from 'react';
import { useKernelStore } from '@/kernel/kernelStores';
import { resolveSourceFocusedBrandId } from '#lib/leasing/sourceFocusedBrand';
import { BrandMark } from '@/components/ui/BrandMark';

export const SourceFocusMark: React.FC = () => {
  // One string per field, so an unrelated brand update does not re-render the chat.
  const name = useKernelStore((state) => {
    const brandId = resolveSourceFocusedBrandId(state as Parameters<typeof resolveSourceFocusedBrandId>[0]);
    const value = brandId ? (state.inventory.Brand.registry[brandId] as { name?: unknown } | undefined)?.name : null;
    return typeof value === 'string' ? value.trim() : '';
  });
  const logoUrl = useKernelStore((state) => {
    const brandId = resolveSourceFocusedBrandId(state as Parameters<typeof resolveSourceFocusedBrandId>[0]);
    const value = brandId ? (state.inventory.Brand.registry[brandId] as { logoUrl?: unknown } | undefined)?.logoUrl : null;
    return typeof value === 'string' ? value : '';
  });
  if (!name) return null;
  return (
    <span className="shrink-0 animate-pulse" title={name} data-source-focus-mark>
      <BrandMark logoUrl={logoUrl || null} name={name} size={18} radius={5} />
    </span>
  );
};
